require('./src/styles/global.css');

const React = require("react")
const { initReactI18N } = require("./src/i18n/i18n");


exports.onClientEntry = initReactI18N
